export function interpolateTemplate(template: string, args: Record<string, string>) {
    return Object.entries(args).reduce((result, [arg, val]) => result.replace(`$\{${arg}}`, `${val}`), template)
}
